module.exports = __webpack_public_path__ + "img/LogoDashboard-32.321936b6.svg";